import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import types from "./types";

export const sellerFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "sellerFetch",
        {
            config,
        },
        undefined,
        undefined,
        "payment"
    );

export const sellerFetchAll = (onResponse?: Function) =>
    request(
        types.FETCH_ALL_REQUEST,
        types.FETCH_ALL_FAILED,
        types.FETCH_ALL_SUCCESS,
        "sellerFetchAll",
        undefined,
        onResponse,
        undefined,
        "payment"
    );

export const sellerGet = (
    id: number,
    config?: AxiosRequestConfig,
    onResponse?: Function
) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "sellerGet",
        {
            config,
            url: {
                id,
            },
        },
        onResponse,
        undefined,
        "payment"
    );

export const sellerPatch = (id: number, data: any, onResponse?: Function) => {
    return request(
        types.PATCH_REQUEST,
        types.PATCH_FAILED,
        types.PATCH_SUCCESS,
        "sellerPatch",
        {
            data,
            url: { id },
        },
        onResponse,
        undefined,
        "payment"
    );
};

export const sellerTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});

export const sellerUpdate = (id: number, data: any, onResponse?: Function) => {
    return request(
        types.UPDATE_REQUEST,
        types.UPDATE_FAILED,
        types.UPDATE_SUCCESS,
        "sellerUpdate",
        {
            data,
            url: { id },
        },
        onResponse,
        undefined,
        "payment"
    );
};

export const sellerSync = (onResponse?: Function) => {
    return request(
        types.SYNC_REQUEST,
        types.SYNC_FAILED,
        types.SYNC_SUCCESS,
        "sellerSync",
        undefined,
        onResponse,
        undefined,
        "payment"
    );
};
